import { CACHE_TIERS } from "@workspace/types";
import type { CalendarViewPreferences } from "@workspace/types/src/entities/user";
import { useSupabase } from "@/components/providers/supabase-auth-provider";
import { trpc } from "@/lib/trpc/react";

/**
 * Default calendar view preferences
 */
export const DEFAULT_CALENDAR_PREFERENCES: CalendarViewPreferences = {
	show_stage_names: false, // Default to showing all stages (false = all, true = filtered)
	show_set_times: true,
	compact_view: false,
	highlight_conflicts: false,
	show_artist_photos: true,
};

/**
 * Hook to fetch and manage user calendar view preferences
 * Returns user preferences with fallback to defaults
 * Now uses tRPC for consistent data fetching pattern
 */
export function useCalendarPreferences() {
	const { user } = useSupabase();

	const {
		data: preferences,
		isLoading,
		refetch,
	} = trpc.settings.getCalendarPreferences.useQuery(undefined, {
		...CACHE_TIERS.DYNAMIC, // User preferences
		retry: false, // Don't retry on failure, just use defaults
		enabled: !!user, // Only run query if user is authenticated
	});

	return {
		preferences: preferences || DEFAULT_CALENDAR_PREFERENCES,
		isLoading,
		refetch,
	};
}
